import React, { useState, useEffect } from "react";
import { DateRangePicker } from 'react-date-range';
import { es } from "date-fns/locale";

import 'react-date-range/dist/styles.css'; // archivo principal de estilos
import 'react-date-range/dist/theme/default.css'; // archivo de estilos de tema
import styles from './MultiDatePicker.module.css';
// onSelectingEndChange(true) mientras falta elegir el día de devolución (después del primer clic del
// rango); false cuando el rango queda completo.
const MultiDatePicker = ({ onChange, fechaCreacion, fechaResolucion, onSelectingEndChange }) => {

    const [date, setDate] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    });
    // Rango y extremo que se está eligiendo ([0, 0] = retiro, [0, 1] = devolución). Lo maneja este
    // componente: DateRangePicker solo avisa el cambio si recibe focusedRange y onRangeFocusChange juntos.
    const [focusedRange, setFocusedRange] = useState([0, 0]);
    const handleRangeFocusChange = (nextFocusedRange) => {
        setFocusedRange(nextFocusedRange);
        if (onSelectingEndChange) onSelectingEndChange(nextFocusedRange[1] === 1);
    };
    const today = new Date();
    today.setHours(0, 0, 0, 0);  // ajusta el dia de hoy a medianoche
    useEffect(() => {
        if (fechaCreacion) {
            // Fechas originales de la solicitud tal cual (también si ya pasaron), las mismas que usan los
            // horarios. Antes el retiro pasado se movía a hoy y el calendario mostraba otro rango.
            setDate({
                startDate: new Date(fechaCreacion),
                endDate: fechaResolucion ? new Date(fechaResolucion) : null,
                key: 'selection',
            });
        }
    }, [fechaCreacion, fechaResolucion]);

    const handleChange = (ranges) => {
        const newDate = {
            startDate: ranges.selection.startDate,
            endDate: ranges.selection.endDate,
            key: 'selection',
        };
        
        if (!newDate.endDate || newDate.endDate.getTime() === newDate.startDate.getTime()) {
            newDate.endDate = newDate.startDate;
        }
        
        setDate(newDate);
        onChange(newDate);
    };
    return (
        <div className={styles.calendario}>
           <DateRangePicker
                className={styles.dateRange}
                ranges={[date]}
                onChange={handleChange}
                focusedRange={focusedRange}
                onRangeFocusChange={handleRangeFocusChange}
                locale={es}
                showDateDisplay={false}
                showMonthAndYearPickers={true}
                showMonthArrow={true}
                minDate={today}
                selectsRange={true}
                moveRangeOnFirstSelection={false}
            />
        </div>
    );
};

export default MultiDatePicker;
